import {
  CloudComputerExpandButton,
  CloudComputerLightbox,
} from '@/features/rpa/cua-cloud/CloudComputerLightbox';
import type {
  ClarificationLoginComputerProps,
  InlineClarificationBlockHost,
  InlineClarificationBlockProps,
} from '@heidi/agents';
import {
  ClarificationLoginComputer as ClarificationLoginComputerView,
  InlineClarificationBlock as InlineClarificationBlockView,
} from '@heidi/agents';
import { lazy } from 'react';
import { ConnectAppChips } from './ConnectAppChips';
import { EhrPickerList } from './EhrPickerList';
import { PatientPickerList } from './PatientPickerList';
import { SessionDocumentPickerList } from './SessionDocumentPickerList';
import { SessionPickerList } from './SessionPickerList';
import { TemplatePickerList } from './TemplatePickerList';

// Lazy so the CUA cloud client (auth/http chain) stays out of the module
// graph unless a ``login_computer`` question actually renders.
const CloudComputerLiveView = lazy(() =>
  import('@/features/rpa/cua-cloud/CloudComputerLiveView').then((m) => ({
    default: m.CloudComputerLiveView,
  }))
);

/** Binds the login card to the cloud resident's live view and lightbox. */
const ClarificationLoginComputer = ({
  disabled,
}: ClarificationLoginComputerProps): JSX.Element => (
  <ClarificationLoginComputerView
    disabled={disabled}
    renderLiveView={({ className }) => <CloudComputerLiveView className={className} />}
    renderExpandButton={(onClick) => <CloudComputerExpandButton onClick={onClick} />}
    renderLightbox={(lightbox) => <CloudComputerLightbox {...lightbox} />}
  />
);

// Module-level so the card sees one stable host for the life of the app.
const CLARIFICATION_HOST: InlineClarificationBlockHost = {
  SessionPickerList,
  PatientPickerList,
  TemplatePickerList,
  EhrPickerList,
  SessionDocumentPickerList,
  ClarificationLoginComputer,
  renderConnectApp: ({ connectors, connectedIds, onConnected, disabled }) => (
    <ConnectAppChips
      connectors={connectors}
      connectedIds={connectedIds}
      onConnected={onConnected}
      disabled={disabled}
      message=""
    />
  ),
};

/**
 * Binds the clarification card to the app's pickers (their data reads), the
 * cloud resident's login view and the integrations-owned connect chips.
 */
export const InlineClarificationBlock = (
  props: InlineClarificationBlockProps
): JSX.Element => <InlineClarificationBlockView {...props} host={CLARIFICATION_HOST} />;
